import { message } from "antd";
import { useMutation, useQueryClient } from "react-query";
import contentApi from "../../../../api/contentApi";
import ListContent from "../../../../components/ListContent";
import PageWrap from "../../../../layout/PageWrap";
import { messages } from "../../../../utils/messages";

const SignList = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(contentApi.deleteSign, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries("content_sign");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  return (
    <PageWrap
      title="Tín hiệu"
      content={
        <ListContent
          headContent="Tín hiệu"
          handleRemove={(e) => mutation.mutate(e)}
          action={useMutation(contentApi.editSign, {
            onSuccess: (data: any) => {
              if (data.statusCode === 200) {
                message.success(messages.updateSuccess);
                queryClient.invalidateQueries("content_sign");
              }
            },
            onError: (err: any) => {
              message.error(err?.data?.message ?? messages.error);
            },
          })}
          keyQuery="content_sign"
          link="/noi-dung-bai-viet/tin-hieu"
          query={contentApi.getSigns}
        />
      }
    />
  );
};

export default SignList;
